"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTING_TAG_RULES = exports.TMONEY_PATTERN = exports.MULTI_BIZ_PATTERN = exports.FLAG_PATTERN = exports.DOWN_SETTING_TAGS = void 0;
/**
 * 서버가 Pay Vcat에 내려주는(DOWN) TAG — 관리자 웹에서 편집·저장 가능한 유일한 집합.
 * 사양서 V0.04 TAG 표의 UP/DOWN 열 (2026-09-07 회신으로 확정). UP 전용 TAG는 표시만 한다.
 * 서버 검증(`PUT …/settings`)과 프론트 편집 가능 판정이 같은 상수를 본다.
 */
exports.DOWN_SETTING_TAGS = [
    'G001',
    'G002',
    'G003',
    'G012',
    'G013',
    'G017',
    'G018',
    'G019',
    'G023',
    'G024',
    'G025',
];
/** 사용여부 플래그 TAG(G012·G013·G017): "1" 사용 / "0" 미사용만 */
exports.FLAG_PATTERN = '^[01]$';
const FLAG_MESSAGE = '사용(1)/미사용(0)만 입력할 수 있습니다.';
/**
 * 다중 사업자(G023, V212): COUNT(2) + DATA(21)×n — DATA = PG여부(1) + 사업자번호(10) + CAT ID/MID(10).
 * COUNT "01"~"10", 반복 수와 COUNT의 일치는 정규식만으로 못 잡으므로 서버가 추가 검사한다.
 */
exports.MULTI_BIZ_PATTERN = '^(0[1-9]|10)([01]\\d{10}[A-Za-z0-9]{10}){1,10}$';
/**
 * 티머니 정보(G025, 17자리): **사용여부(1) + 가맹점ID(7) + 단말기ID(9)**.
 *
 * ⚠ 사양서 **V0.07**(2026-09-17 수령)에서 구성이 바뀌었다 — V0.06까지는 `사용여부(1) + SAMID(≤20)`
 * 였고, V0.04가 *"구조만 구성 가능하도록"*이라 예고했던 그 변경이다.
 *
 * ── 비사용("0")일 때 뒤 16자리 (사양서에 정의 없음 → 우리가 정한다) ──────────────
 * 단말은 모자란 칸을 **우측 스페이스로 채운다**(2026-09-09 소장 답변서 ④). 그 값은 관리자·단말
 * 양쪽에서 `normalizeSettingValue`/`trimPadding`이 먼저 걷어내므로 여기 닿을 때는 `"0"` 한 자다
 * (`apps/server/src/merchants/terminal-setting-rules.ts`). 그래서 **비사용은 뒤 16자리를 비운
 * `"0"`과 채워 보낸 `"0"+16자` 둘 다 받는다** — 쓰지 않는 단말에 가맹점ID·단말기ID를 지어내게
 * 할 이유가 없다. 사용("1")은 17자리를 모두 요구한다(그 값이 곧 티머니 등록 키다).
 */
exports.TMONEY_PATTERN = '^(?:1[A-Za-z0-9]{7}[A-Za-z0-9]{9}|0(?:[A-Za-z0-9]{7}[A-Za-z0-9]{9})?)$';
/** DOWN TAG별 검증 규칙 — 서버 400 판정과 프론트 폼 검증의 단일 소스 */
exports.SETTING_TAG_RULES = {
    // G001·G003·G024 길이는 **V0.05 답변(2026-09-08 이성진)으로 확정**됐다 — 사양서 표기
    // `V20`/`10`/`V50`. 사양서의 V표기는 CP949 바이트라 maxBytes로 걸고, maxLength는 ASCII 상한이다
    // (G019가 쓰던 방식과 같다). 확인 전 임시로 두었던 컬럼 상한 500은 걷어냈다
    G001: { maxLength: 20, maxBytes: 20, message: 'VAN 사는 20바이트(한글 10자) 이내입니다.' },
    // G002는 사양서에 길이 표기가 없었는데 V0.06에서 `(1)`이 붙어 1자리로 확정됐다.
    // 값은 VAN_PG_TAG_VALUE와 같은 '0'/'1' — 폼은 체크박스라 다른 값이 들어올 자리가 없지만,
    // 서버는 전문으로도 받으므로 형식을 함께 건다
    G002: { maxLength: 1, pattern: exports.FLAG_PATTERN, message: 'VAN/PG는 VAN(0)/PG(1) 1자리입니다.' },
    G003: { maxLength: 10, maxBytes: 10, message: '단말기 번호는 10자 이내입니다.' },
    G012: { maxLength: 1, pattern: exports.FLAG_PATTERN, message: FLAG_MESSAGE },
    G013: { maxLength: 1, pattern: exports.FLAG_PATTERN, message: FLAG_MESSAGE },
    G017: { maxLength: 1, pattern: exports.FLAG_PATTERN, message: FLAG_MESSAGE },
    G018: { maxLength: 10, pattern: '^\\d{10}$', message: '사업자번호는 숫자 10자리입니다.' },
    // 사양 V40 = CP949 40바이트 (한글 20자). V0.06에서 V30 → V40으로 올라가 가맹점 정보 확인
    // 응답(0009)의 가맹점명과 통일됐다 (2026-09-08 답변 "40으로 통일 시켜서 반영했습니다")
    G019: { maxLength: 40, maxBytes: 40, message: '가맹점명은 40바이트(한글 20자) 이내입니다.' },
    G023: {
        maxLength: 212,
        pattern: exports.MULTI_BIZ_PATTERN,
        message: '다중 사업자는 COUNT(01~10) 뒤에 [PG여부 1자리 + 사업자번호 10자리 + CAT ID/MID 10자리]가 COUNT만큼 반복되는 형식입니다.',
    },
    G024: { maxLength: 50, maxBytes: 50, message: 'POS 개발사는 50바이트(한글 25자) 이내입니다.' },
    G025: {
        maxLength: 17,
        pattern: exports.TMONEY_PATTERN,
        message: '티머니 정보는 사용여부(0/1) 1자리 + 가맹점ID 7자리 + 단말기ID 9자리(영문·숫자)입니다. 비사용이면 "0"만 넣습니다.',
    },
};
